<ul class="nav-links__list">
    <li
        *ngFor="let item of items"
        class="nav-links__item"
        [ngClass]="{
            'nav-links__item--has-submenu': item.menu,
            'nav-links__item--hover': hoveredItem === item
        }"
        (mouseenter)="onItemMouseEnter(item)"
        (mouseleave)="onItemMouseLeave(item)"
        (focusout)="onItemFocusOut($event, item)"
        (keydown.escape)="onItemMouseLeave(item)"
        (appOutsideTouchClick)="onOutsideTouchClick(item)"
        #itemElement
    >

        <ng-template #link>
            <span class="nav-links__item-body">
                {{ item.key ? (item.key | t:item.label) : item.label }}
                <app-icon *ngIf="item.menu" class="nav-links__item-arrow" name="arrow-rounded-down-9x6" size="9x6"></app-icon>
            </span>
        </ng-template>

        <a *ngIf="item.url && !item.external" class="nav-links__item-link" [routerLink]="item.url" [target]="item.target" (appTouchClick)="onTouchClick($event, item)">
            <ng-container [ngTemplateOutlet]="link"></ng-container>
        </a>
        <a *ngIf="item.url && item.external" class="nav-links__item-link" [href]="item.url" [target]="item.target" (appTouchClick)="onTouchClick($event, item)">
            <ng-container [ngTemplateOutlet]="link"></ng-container>
        </a>
        <!-- A parent with no page of its own (Brands): a button that opens its menu, not a
             link to nowhere. Its menu is drawn in the browser only (the server's HTML stays short). -->
        <button *ngIf="!item.url" type="button" class="nav-links__item-link nav-links__item-link--button" [attr.aria-expanded]="hoveredItem === item" (click)="onParentClick(item)" (appTouchClick)="onTouchClick($event, item)">
            <ng-container [ngTemplateOutlet]="link"></ng-container>
        </button>

        <div
            *ngIf="isBrowser && item.menu && item.menu.type == 'menu'"
            class="nav-links__submenu nav-links__submenu--type--menu"
            [ngClass]="{'nav-links__submenu--open': hoveredItem === item}"
            #submenuElement
        >
            <app-header-menu [items]="item.menu.items" (itemClick)="onSubItemClick()"></app-header-menu>
        </div>
        <div
            *ngIf="isBrowser && item.menu && item.menu.type == 'megamenu'"
            class="nav-links__submenu nav-links__submenu--type--megamenu nav-links__submenu--size--{{ item.menu.size }}"
            [ngClass]="{'nav-links__submenu--open': hoveredItem === item}"
            #submenuElement
        >
            <app-header-megamenu [menu]="item.menu" (itemClick)="onSubItemClick()"></app-header-megamenu>
        </div>
    </li>
</ul>
